<template>
  <div id="con" v-bind:class="returnStyle()">
    <h1 class="bottomLine">{{ title }}</h1>
    <div v-for="(x, i) in arr" :key="i" class="item">
      <p v-html="x" class="content"></p>
    </div>
  </div>
</template>

<style scoped>
#con {
  border-radius: 4px;
  background-color: #ffffff;
  text-align: left;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  text-align: left !important;
}
#con > h1 {
  font-size: 18px;
  color: #303133;
  padding: 16px;
}

.bottomLine {
  position: relative;
}
.bottomLine::after {
  content: "";
  position: absolute;
  left: 16px;
  right: 16px;
  bottom: 0;
  height: 1px;
  background-color: #e4e7ed;
}
.item {
  padding: 8px 16px;
}
.item > .content {
  font-size: 18px;
  color: #303133;
  line-height: 28px;
}
.style2 {
  overflow: hidden;
  margin-bottom: 64px !important;
}
.style2 > h1 {
  background-color: #409eff;
  color: #ffffff !important;
}
.style2 > h1::after {
  content: none;
}
</style>

<script>
export default {
  name: "UserInfo",
  props: ["title", "arr", "style_blue"],
  methods: {
    returnStyle() {
      let that = this;
      return {
        style2: that.style_blue == true
      };
    }
  }
};
</script>
